import { render, staticRenderFns } from "./manage-templates.vue?vue&type=template&id=eeb72c62&scoped=true"
import script from "./manage-templates.vue?vue&type=script&lang=js"
export * from "./manage-templates.vue?vue&type=script&lang=js"
import style0 from "./manage-templates.vue?vue&type=style&index=0&id=eeb72c62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb72c62",
  null
  
)

export default component.exports